import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router';

import NavBar from './components/NavBar';

import './App.css';
import { initFontAwesome } from '@relyant/ui';
import ResearchView from './views/ResearchView/ResearchView';
import ReviewView from './views/ReportReview/Review';
import ProfileView from './views/Profile/ProfileView';
import AdminView from './views/Admin/AdminView';
import IntegrationView from './views/IntegrationView/IntegrationView';
import { RelyantAssistantView as AssistantView } from '@relyant/ui';
import OrdersView from './views/OrdersView/OrdersView';
import InvoicesView from './views/InvoicesView/InvoicesView';
import CVReportGenerationView from './views/ReportGeneration/CVReportGeneration';
import { Loading, LoginView, OrganizationView, useOrganization } from '@relyant/ui';
import { useAuth0 } from '@auth0/auth0-react';
import { getRoutes } from './feature_config';

initFontAwesome();

const routeMapping = {
  '/': <CVReportGenerationView />,
  '/admin': <AdminView />,
  '/assistant': <Navigate to="/assistant/flows" />,
  'assistant/flows': <AssistantView />,
  'assistant/logs': <AssistantView />,
  '/login': <LoginView />,
  '/orders': <OrdersView />,
  '/integrations': <IntegrationView />,
  '/invoices': <InvoicesView />,
  '/profile': <ProfileView />,
  '/reports': <CVReportGenerationView />,
  '/report-review': <ReviewView />,
  '/research': <ResearchView />,
};

const App = () => {
  const { organization, isLoading } = useOrganization();
  const { isAuthenticated } = useAuth0();
  // console.log({ organization, isAuthenticated, isLoading });
  if (isLoading) {
    return <Loading />;
  }

  if (isAuthenticated && !organization) {
    return (
      <Router>
        <div id="app">
          <NavBar withSideBar={false}>
            <OrganizationView />;
          </NavBar>
        </div>
      </Router>
    );
  }

  const routes = getRoutes(organization);
  routes.push('/login');

  return (
    <Router>
      <div id="app">
        <NavBar>
          <div className="" style={{}}>
            <Routes>
              {routes.map((route, index) => (
                <Route key={index} path={route} exact element={routeMapping[route]} />
              ))}
            </Routes>
          </div>
        </NavBar>
      </div>
    </Router>
  );
};

export default App;
